<div class="loading-overlay" [hidden]="!service.viewModel.isLoadingConfiguration">
	<img class="spinner" src="./assets/spinner2.gif" />
</div>

<div class="scrollable-section" [hidden]="service.viewModel.isLoadingConfiguration">
	<div class="flex gap-16 flex-align-center">
		<h2 class="mat-heading flex-1">{{ 'masterdata.carting.config.label' | translate }}</h2>
		<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems"></header-sub-menu>
	</div>
	<mat-accordion multi [@.disabled]="true">
		<mat-expansion-panel expanded="true">
			<mat-expansion-panel-header>
				<mat-panel-title>
					{{ 'masterdata.carting.config.general' | translate }}
				</mat-panel-title>
				<div class="v-divider"></div>
			</mat-expansion-panel-header>

			<form class="flex flex-dir-col mw-400 pt-16 gap-8" [formGroup]="service.viewModel.form">
				<mat-form-field appearance="outline" class="dialog">
					@if (service.viewModel.controls['maxProductionSequenceNumberJumpsInSameWagon']?.invalid) {
						<mat-error>
							{{ 'masterdata.carting.config.errors.validation.maxProductionSequenceNumberJumpsInSameWagon' | translate }}
						</mat-error>
					}
					<mat-label class="mat-body-1">
						{{ 'masterdata.carting.config.maxProductionSequenceNumberJumpsInSameWagon' | translate }}
					</mat-label>
					<input OnlyNumbers matInput [formControlName]="'maxProductionSequenceNumberJumpsInSameWagon'" (blur)="updateConfiguration()" [(ngModel)]="service.viewModel.maxProductionSequenceNumberJumpsInSameWagon" />
				</mat-form-field>
				<mat-checkbox [disabled]="service.viewModel.form.invalid" [ngModelOptions]="{ standalone: true }" [(ngModel)]="service.viewModel.splitDoorAndWindowSashes" (ngModelChange)="updateConfiguration()">
					{{ 'masterdata.carting.config.splitDoorAndWindowSashes' | translate }}
				</mat-checkbox>
				<mat-checkbox [disabled]="service.viewModel.form.invalid" [ngModelOptions]="{ standalone: true }" [(ngModel)]="service.viewModel.groupByColors" (ngModelChange)="updateConfiguration()">
					{{ 'masterdata.carting.config.groupByColors' | translate }}
				</mat-checkbox>
				<h2 class="mat-heading">
					{{ 'masterdata.carting.config.newWagonTitle' | translate }}
				</h2>
				<mat-checkbox [disabled]="service.viewModel.form.invalid" [ngModelOptions]="{ standalone: true }" [(ngModel)]="service.viewModel.productionRoute" (ngModelChange)="updateConfiguration()">
					{{ 'masterdata.carting.config.productionRoute' | translate }}
				</mat-checkbox>
				<mat-checkbox [disabled]="service.viewModel.form.invalid" [ngModelOptions]="{ standalone: true }" [(ngModel)]="service.viewModel.paintInside" (ngModelChange)="updateConfiguration()">
					{{ 'masterdata.carting.config.paintInside' | translate }}
				</mat-checkbox>
				<mat-checkbox [disabled]="service.viewModel.form.invalid" [ngModelOptions]="{ standalone: true }" [(ngModel)]="service.viewModel.profileSet" (ngModelChange)="updateConfiguration()">
					{{ 'masterdata.carting.config.profileSet' | translate }}
				</mat-checkbox>
				<mat-checkbox [disabled]="service.viewModel.form.invalid" [ngModelOptions]="{ standalone: true }" [(ngModel)]="service.viewModel.profileSetGroup" (ngModelChange)="updateConfiguration()">
					{{ 'masterdata.carting.config.profileSetGroup' | translate }}
				</mat-checkbox>
				<mat-checkbox [disabled]="service.viewModel.form.invalid" [ngModelOptions]="{ standalone: true }" [(ngModel)]="service.viewModel.geometry" (ngModelChange)="updateConfiguration()">
					{{ 'masterdata.carting.config.geometry' | translate }}
				</mat-checkbox>
			</form>
		</mat-expansion-panel>

		<mat-expansion-panel expanded="true">
			<mat-expansion-panel-header>
				<mat-panel-title>
					{{ 'masterdata.carting.config.sorting.label' | translate }}
				</mat-panel-title>
				<div class="v-divider"></div>
			</mat-expansion-panel-header>

			<div class="flex flex-dir-col pt-16 gap-8 mw-700">
				<!-- Group Sorting -->
				<h2 class="m-0">
					{{ 'masterdata.carting.config.sorting.groupSorting' | translate }}
				</h2>
				@for (item of service.viewModel.groupSortingFormFieldsLookup; track item.property) {
					<div class="flex gap-64">
						<mat-checkbox class="flex-1" [(ngModel)]="service.viewModel[item.property]" (ngModelChange)="updateConfiguration()">
							{{ 'masterdata.carting.config.sorting.' + item.property | translate }}
						</mat-checkbox>

						<mat-checkbox [(ngModel)]="service.viewModel[item.property + 'Order']" [disabled]="!service.viewModel[item.property]" (ngModelChange)="updateConfiguration()">
							{{ 'masterdata.carting.config.sorting.ascending' | translate }}
						</mat-checkbox>

						<mat-form-field [formGroup]="service.viewModel.groupSortingPriorityForm" appearance="outline" class="dialog mw-200">
							@if (service.viewModel.groupSortingPriorityControls[item.property + 'Priority']?.invalid) {
								<mat-error>
									{{ 'masterdata.carting.config.errors.validation.priority' | translate }}
								</mat-error>
							}
							<mat-label class="mat-body-1">
								{{ 'masterdata.carting.config.priority' | translate }}
							</mat-label>
							<input OnlyNumbers matInput [formControlName]="item.property + 'Priority'" (blur)="updateConfiguration()" (ngModelChange)="updatePriorityFormValidity()" [(ngModel)]="service.viewModel[item.property + 'Priority']" />
						</mat-form-field>
					</div>
				}

				<!-- Component Sorting -->
				<h2 class="m-0">
					{{ 'masterdata.carting.config.sorting.componentSorting' | translate }}
				</h2>
				@for (item of service.viewModel.componentSortingFormFieldsLookup; track item.property) {
					<div class="flex gap-64">
						<mat-checkbox class="flex-1" [(ngModel)]="service.viewModel[item.property]" (ngModelChange)="updateConfiguration()">
							{{ 'masterdata.carting.config.sorting.' + item.property | translate }}
						</mat-checkbox>

						<mat-checkbox [(ngModel)]="service.viewModel[item.property + 'Order']" [disabled]="!service.viewModel[item.property]" (ngModelChange)="updateConfiguration()">
							{{ 'masterdata.carting.config.sorting.ascending' | translate }}
						</mat-checkbox>

						<mat-form-field [formGroup]="service.viewModel.componentSortingPriorityForm" appearance="outline" class="dialog mw-200">
							@if (service.viewModel.componentSortingPriorityControls[item.property + 'Priority']?.invalid) {
								<mat-error>
									{{ 'masterdata.carting.config.errors.validation.priority' | translate }}
								</mat-error>
							}
							<mat-label class="mat-body-1">
								{{ 'masterdata.carting.config.priority' | translate }}
							</mat-label>
							<input OnlyNumbers matInput [formControlName]="item.property + 'Priority'" (blur)="updateConfiguration()" (ngModelChange)="updatePriorityFormValidity()" [(ngModel)]="service.viewModel[item.property + 'Priority']" />
						</mat-form-field>
					</div>
				}
			</div>
		</mat-expansion-panel>
	</mat-accordion>
</div>
